import { Outlet } from 'react-router-dom';
import { WorkspacesSidebar } from '../../components/Workspaces/WorkspacesSidebar';

export const HomeScreenLayout = () => (
  <div className="flex flex-grow flex-shrink-0 basis-0 min-h-0 no-drag">
    <WorkspacesSidebar />
    <Outlet />
  </div>
);
